import React from "react";
import { Link } from "react-router-dom";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { UserPermission } from "../../types/userPermission";

const AdminDefault = () => {
    const aplSettings = AplSettingsSelector();

    const permAdmin =
        aplSettings.hasPermAnyLine(UserPermission.Admin) ||
        aplSettings.hasPermAnyLine(UserPermission.GlobalPermsAdmin) ||
        aplSettings.hasPermAnyLine(UserPermission.SuperAdmin);

    return (
        <React.Fragment>
            {/* <!-- admin permissions--> */}
            {permAdmin ? (
                <React.Fragment>
                    <li id="navbarAdminUsersAdmin">
                        <Link id="navbarAdminUsersAdminLink" to={"/admin/usersadmin"}>
                            Users Permissions
                        </Link>
                    </li>
                    <li id="navbarAdminPritnersAssignment">
                        <Link id="navbarAdminPritnersAssignmentLink" to={"/admin/printerline"}>
                            Printers Assignment
                        </Link>
                    </li>
                    {/* <!-- admin sqldeploy--> */}
                    <li id="navbarAdminSqlDeploy">
                        <Link id="navbarAdminSqlDeployLink" to={"/admin/sqldeploy"}>
                            SQL Deploy
                        </Link>
                    </li>
                </React.Fragment>
            ) : (
                ""
            )}
            {permAdmin ? (
                <React.Fragment>
                    <li id="navbarAdminRoleEditor">
                        <Link id="navbarAdminRoleEditorLink" to={"/admin/rolefeature"}>
                            Roles Admin
                        </Link>
                    </li>
                </React.Fragment>
            ) : (
                ""
            )}

            {/* <!-- change password --> */}
            <li id="navbarAdminChangePassword">
                <Link id="navbarAdminChangePasswordLink" to={"/user/password"}>
                    Change Password
                </Link>
            </li>
        </React.Fragment>
    );
};

export default AdminDefault;
